import React from 'react';

function NavBtn({ id, label, active, onClick, children, badge }) {
  return (
    <button
      type="button"
      className={`mdv-mobile-nav-btn ${active ? 'is-active' : ''}`}
      onClick={onClick}
      aria-label={label}
      aria-pressed={active}
      data-nav={id}
    >
      <span className="mdv-mobile-nav-icon" aria-hidden>
        {children}
        {badge ? <span className="mdv-mobile-nav-badge">{badge}</span> : null}
      </span>
      <span className="mdv-mobile-nav-label">{label}</span>
    </button>
  );
}

const iconProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.8',
  className: 'h-5 w-5',
};

/**
 * Always-visible phone tool bar. Labels stay on screen so nothing is icon-only.
 */
export default function MobileNav({
  layersActive,
  onLayers,
  toolsActive,
  onTools,
  drawActive,
  onDraw,
  findActive,
  onFind,
  viewsActive,
  onViews,
  moreActive,
  onMore,
  loadingCount = 0,
}) {
  return (
    <nav className="mdv-mobile-nav" aria-label="Scene tools">
      <NavBtn id="layers" label="Layers" active={layersActive} onClick={onLayers}>
        <svg {...iconProps}>
          <path d="M4 6h16M4 12h16M4 18h10" strokeLinecap="round" />
        </svg>
      </NavBtn>
      <NavBtn id="tools" label="Tools" active={toolsActive} onClick={onTools}>
        <svg {...iconProps}>
          <path d="M4 20L20 4M8 20h4M12 16h4M4 12v4" strokeLinecap="round" />
        </svg>
      </NavBtn>
      <NavBtn id="draw" label="Draw" active={drawActive} onClick={onDraw}>
        <svg {...iconProps}>
          <path d="M4 20l4.5-1.2L19 8.3a2.1 2.1 0 00-3-3L5.5 15.8 4 20z" strokeLinejoin="round" />
        </svg>
      </NavBtn>
      <NavBtn id="find" label="Find" active={findActive} onClick={onFind}>
        <svg {...iconProps}>
          <circle cx="11" cy="11" r="6.5" />
          <path d="M16 16l4 4" strokeLinecap="round" />
        </svg>
      </NavBtn>
      <NavBtn id="views" label="Views" active={viewsActive} onClick={onViews}>
        <svg {...iconProps}>
          <path d="M4 7h16M4 12h10M4 17h16" strokeLinecap="round" />
          <circle cx="18" cy="12" r="1.6" fill="currentColor" />
        </svg>
      </NavBtn>
      <NavBtn
        id="more"
        label="More"
        active={moreActive}
        onClick={onMore}
        badge={loadingCount > 0 ? String(loadingCount) : null}
      >
        <svg {...iconProps}>
          <circle cx="6" cy="12" r="1.6" fill="currentColor" />
          <circle cx="12" cy="12" r="1.6" fill="currentColor" />
          <circle cx="18" cy="12" r="1.6" fill="currentColor" />
        </svg>
      </NavBtn>
    </nav>
  );
}

export function MobileMoreList({ items }) {
  return (
    <ul className="mdv-mobile-more-list">
      {items.map((item) => (
        <li key={item.id}>
          <button type="button" className="mdv-mobile-more-item" onClick={item.onClick}>
            <span className="mdv-mobile-more-item-icon" aria-hidden>
              {item.icon}
            </span>
            <span className="mdv-mobile-more-item-text">
              <span className="mdv-mobile-more-item-label">{item.label}</span>
              {item.hint ? <span className="mdv-mobile-more-item-hint">{item.hint}</span> : null}
            </span>
            {item.badge ? <span className="mdv-mobile-more-item-badge">{item.badge}</span> : null}
          </button>
        </li>
      ))}
    </ul>
  );
}
